import React from 'react';
import { Layout } from 'app/components/base/Layout';
import { FormattedMessage } from 'translations';
import { Link } from 'react-router-dom';
import style from './style.css';

const messages = {
  title: { id: 'NOT_FOUND.TITLE' },
  subtitle: { id: 'NOT_FOUND.SUBTITLE' },
  message: { id: 'NOT_FOUND.MESSAGE' },
  messageCta: { id: 'NOT_FOUND.MESSAGE_CTA' },
  button: { id: 'NOT_FOUND.TAKE_ME_HOME' },
};

const NotFoundRoute = () => (
  <Layout
    nowrap
    size="noshrink"
    align="center stretch"
    direction="column"
    className={style.container}
  >
    <Layout
      nowrap
      align="center center"
      direction="column"
      className={style.wrapper}
    >
      <h1 className={style.title}>
        <FormattedMessage {...messages.title} />
      </h1>
      <h2 className={style.subtitle}>
        <FormattedMessage {...messages.subtitle} />
      </h2>
      <p className={style.message}>
        <FormattedMessage {...messages.message} />
        <br />
        <FormattedMessage {...messages.messageCta} />
      </p>
      <Link to="/">
        <button className={style.button}>
          <FormattedMessage {...messages.button} />
        </button>
      </Link>
    </Layout>
  </Layout>
);

export default NotFoundRoute;
